export const loginPath = "https://adshmtier.adshospital.com/api/Auth/V1/";
export const apiPath = "https://adshmtier.adshospital.com/api/V1/"
export const apiPath2 = "https://adshmtier.adshospital.com/api/Visitor/V1/"
//export const apiPath3 = "https://fourvista.com/testyourapp/olep/olep-api/public/api/examination/"

// export const apiPath = "https://ads-api.adshospital.site/api/V1/"
// export const apiPath2 = "https://ads-api.adshospital.site/api/Visitor/V1/"
